<template>
  <div class="live-content">
    <div class="living-num">
      当前在线人数:
      {{ liveOnlineNum }}
      人
    </div>
    <div class="live-message-list">
      <el-scrollbar
        ref="scrollBar"
        class="chat-list"
      >
        <transition-group
          name="list"
          tag="div"
        >
          <chatMsgItem
            v-for="(item) in chatList"
            :key="item.key"
            :item="item"
          />
        </transition-group>
      </el-scrollbar>
      <div class="bottom-item">
        <el-input
          v-model="message"
          type="textarea"
          :rows="2"
          placeholder="这里输入聊天内容"
          @keydown.native="send($event)"
        />
        <svg-icon
          name="qr-code"
          class="qr-code"
          @click.native="openSendImgDialog"
        />
        <el-button
          type="primary"
          @click.native="sendMessage()"
        >
          发送
        </el-button>
      </div>
    </div>
    <chatPicDialog
      :dialog-visible.sync="imgDialogVisible"
      @getImg="getImg"
    />
  </div>
</template>
<script>
import untils from '@/util';
import { mapGetters } from 'vuex';
import axClient from '@/services';
import { setTimeout } from 'timers';
import chatMsgItem from './chatMsgItem.vue';
import chatPicDialog from './chatPicDialog.vue';

export default {
  name: 'FomTitle',
  components: {
    chatMsgItem,
    chatPicDialog,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      message: '',
      chatList: [],
      lockSend: false,
      imgDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'liveOnlineNum', 'socketMsg']),
  },
  watch: {
    socketMsg(value) {
      console.log(value);
      // 数据变化插入一条 最多一百条 只有图片和文字信息才会收集
      if (value.messageType === 20 || value.messageType === 30 || value.messageType === 25) {
        if (this.chatList.length === 100) {
          this.chatList.shift();
        }
        this.chatList.push(Object.assign(value, { key: new Date().getTime() }));
        this.$nextTick(() => {
          this.$refs.scrollBar.wrap.scrollTop = this.$refs.scrollBar.wrap.scrollHeight;
        });
      }
    },
  },
  mounted() {
    untils.contentSocket(this.id, this.user.id);
  },
  methods: {
    // 发送消息
    async send(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.sendMessage();
      }
      return true;
    },
    // 发送消息
    async sendMessage() {
      if (this.message === '') {
        this.$message.error('请输入聊天内容!');
        return false;
      }
      if (this.lockSend) {
        this.$message.error('3s内只能发言一次');
        return false;
      }
      this.lockSend = true;
      const data = await axClient.live.sendLiveChatMsg({
        content: this.message,
        messageTypeEnum: 'TEXT_MSG',
        roomId: this.id,
      });
      if (data) {
        this.message = '';
      }
      setTimeout(() => {
        this.lockSend = false;
      }, 3000);
      return true;
    },
    // 发送图片
    async getImg(val) {
      await axClient.live.sendLiveChatMsg({
        content: val,
        messageTypeEnum: 'PIC_MSG',
        roomId: this.id,
      });
    },
    // 打开发送图片弹窗
    openSendImgDialog() {
      this.imgDialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.live-content{
 .living-num{
   color: $--base-color-main;
   font-size: 14px;
 }
 .live-message-list{
   margin: 15px 0;
   padding-top: 15px;
   background: #ffffff;
   position:relative;
   padding-bottom: 85px;
   border-radius: 8px;
   .bottom-item{
      position: absolute;
      bottom:0;
      right: 0;
      left: 0;
      .qr-code{
        color: $--base-color-main;
        position: absolute;
        font-size: 30px;
        right: 64px;
        top: 2px;
        cursor: pointer;
      }
     ::v-deep textarea{
        border-color: $--base-color-main;
        border-width: 2px;
        padding-right: 75px
      }
      button{
        position: absolute;
        right: 0;
        top:0;
        min-width: 40px;
        bottom: 0;
      }
    }
   .chat-list{
    height: 200px;
    min-height: 150px;
    .list-enter-active, .list-leave-active {
      transition: all 0.6s;
    }
    .list-enter, .list-leave-to{
      opacity: 0;
      transform: translateY(30px);
    }
   }
 }
}
</style>
